export default __webpack_public_path__ + "static/trevor1-a2983ca0255526962a38aedab0561ad9.jpg";